"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScopedThemeProps = exports.default = void 0;
var _react = require("react");
var _context = require("../context");
var _utils = require("../utils");
/**
 * Hook to simplify the usage of scoped theme props.
 * It automatically retrieves the scopeId from context and applies it.
 *
 * @param {Object} options - Configuration options
 * @param {boolean} [options.isInvertedColorScheme] - Optional flag to use inverted color scheme (dark mode colors)
 * @returns {Object} - Props to be spread on a component for scoped theming
 *
 * @example
 * // Basic usage
 * const scopedThemeProps = useScopedThemeProps();
 * return <Component {...scopedThemeProps} />;
 *
 * @example
 * // With inverted color scheme
 * const scopedThemeProps = useScopedThemeProps({ isInvertedColorScheme: true });
 * return <Component {...scopedThemeProps} />;
 */
const useScopedThemeProps = function () {
  let {
    isInvertedColorScheme
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const scopeId = (0, _react.useContext)(_context.ScopeContext);
  return (0, _utils.getScopedThemeProps)({
    scopeId,
    isInvertedColorScheme
  });
};
exports.useScopedThemeProps = useScopedThemeProps;
var _default = exports.default = useScopedThemeProps;